import { API_ADMIN_URL } from '../../config/constants'
import { postRequest } from '../API'

const UNAVAILABLE = "Under Maintenance, Please try after some time.";

const send = async (path, postData) => {
    try {
        const res = await postRequest({ url: `${API_ADMIN_URL}publications/${path}`, postData });
        if (res.status === true || res.status === 200) {
            return { status: true, ...res?.data?.response };
        }
        return { status: false, message: res?.response?.data?.statusMessage || UNAVAILABLE };
    } catch (error) {
        console.log(error);
        return { status: false, message: UNAVAILABLE };
    }
};

/*********************************************************
* Function Name : list
* Description   : All editions (newest first) + the series list
* Date          : 04-10-2026
*********************************************************/
export const list = () => send('list', {});

/*********************************************************
* Function Name : save
* Description   : Add/Edit an edition -- `form` is a FormData with the
*                 fields plus optional `pdf` and `cover` files
* Date          : 04-10-2026
*********************************************************/
export const save = (form) => send('addeditdata', form);

/*********************************************************
* Function Name : changeStatus
* Description   : Publish ("A") or hide ("I") an edition
* Date          : 04-10-2026
*********************************************************/
export const changeStatus = (postData) => send('change-status', postData);

/*********************************************************
* Function Name : remove
* Description   : Delete an edition and its files
* Date          : 04-10-2026
*********************************************************/
export const remove = (postData) => send('delete', postData);
